import React, { useState } from 'react';
import LandingNav from './components/LandingNav';
import LandingFooter from './components/LandingFooter';
import './landing.scss';

const FAQ_ITEMS = [
  {
    q: "I can't log in — what should I do?",
    a: "Ensure your credentials are correct. If it's your first login, use the temporary password provided by your administrator. If you've forgotten your password, use the \"Forgot Password\" link on the login screen. For persistent issues, contact your system administrator.",
  },
  {
    q: "I don't see any rooms or devices in the app.",
    a: "Rooms and devices are configured by your building administrator through the management dashboard. If nothing appears, ask your administrator to verify your account has the correct access permissions assigned.",
  },
  {
    q: "How do I reset my password?",
    a: "Tap \"Forgot Password\" on the login screen, enter your email address, and follow the OTP verification steps. If you have a first-login temporary password, you will be prompted to change it automatically after signing in.",
  },
  {
    q: "The app shows a connection error.",
    a: "Ensure your device has an active internet connection. The Manzili Smart app requires network access to communicate with the building management system. If the issue persists, the backend service may be temporarily unavailable — please try again shortly.",
  },
  {
    q: "I'm a property manager. How do I get started?",
    a: "Manzili Smart is a B2B platform. To set up an account for your property, contact us at info@manzilismart.com. We'll provision a partner account and provide onboarding guidance for your building management team.",
  },
  {
    q: "How do I add or remove users from my building?",
    a: "Log in to the admin dashboard at manzilismart.com. Navigate to Admin → Users to create, deactivate, or manage users within your licensed partner account. Only ADMIN and MANAGER roles can manage users.",
  },
  {
    q: "Is my data secure?",
    a: "Yes. All data is encrypted in transit (HTTPS/TLS) and at rest. Authentication uses JWT tokens stored securely on your device. The platform is hosted on AWS infrastructure with access controls enforced at every level. See our Privacy Policy for full details.",
  },
];

const FaqItem = ({ q, a }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`faq-item${open ? ' faq-item--open' : ''}`}>
      <button className="faq-q" onClick={() => setOpen(o => !o)}>
        {q}
        <span className="faq-chevron">{open ? '−' : '+'}</span>
      </button>
      {open && <p className="faq-a">{a}</p>}
    </div>
  );
};

const SupportPage = () => (
  <div className="landing-page">
    <LandingNav />

    <div className="policy-hero">
      <div className="policy-hero-inner">
        <span className="policy-badge">Help &amp; Support</span>
        <h1>Support</h1>
        <p className="policy-meta">We're here to help. Reach out anytime.</p>
      </div>
    </div>

    <div className="policy-content">
      <div className="policy-inner">
        <div className="support-grid">

          <div className="support-contact-card">
            <h3>Contact Us</h3>

            <div className="contact-item">
              <div className="contact-icon">✉</div>
              <div>
                <span className="contact-label">Email</span>
                <span className="contact-value">
                  <a href="mailto:info@manzilismart.com">info@manzilismart.com</a>
                </span>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">☎</div>
              <div>
                <span className="contact-label">Phone</span>
                <span className="contact-value">+974 6000 2681</span>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">⌖</div>
              <div>
                <span className="contact-label">Address</span>
                <span className="contact-value">
                  2nd Floor, Apt. 12, Building 76<br />
                  Zone 27, Street 230, C-ring Road<br />
                  Doha, Qatar 11926
                </span>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">⊕</div>
              <div>
                <span className="contact-label">Website</span>
                <span className="contact-value">
                  <a href="https://epo-power.com" target="_blank" rel="noopener noreferrer">epo-power.com</a>
                </span>
              </div>
            </div>

            <div className="support-note">
              <p>
                Response time: within 1 business day.<br />
                Business hours: Sun–Thu, 8 AM–5 PM AST.
              </p>
            </div>
          </div>

          <div className="support-faq">
            <h3>Frequently Asked Questions</h3>
            {FAQ_ITEMS.map((item, i) => (
              <FaqItem key={i} q={item.q} a={item.a} />
            ))}
          </div>

        </div>
      </div>
    </div>

    <LandingFooter />
  </div>
);

export default SupportPage;
